import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import "./index.css";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// --- Old Azure (MSAL) login — commented out, kept for reference ---
// import { msalConfig } from "./config/msalConfig";
// import { PublicClientApplication } from "@azure/msal-browser";
import { ThemeContextProvider } from "./context/themeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
// const msalInstance = new PublicClientApplication(msalConfig);

root.render(
  // <React.StrictMode>
  <ThemeContextProvider>
    {/* Old Azure login passed the MSAL instance in: <App instance={msalInstance} /> */}
    <App />
  </ThemeContextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
